import React, { useContext, useEffect, useState } from 'react'
import SearchContext from 'modules/react/search/SearchContext'
import classNames from 'classnames'

export default function ResetButton ({ afterSearch = false }) {

  const [showButton, setShowButton] = useState(false)
  const { selectedFilters, unselectAllFilters } = useContext(SearchContext)

  const showButtonIfFiltersIsset = () => {
    setShowButton(false)
    Object.keys(selectedFilters).map(filterSlug => {
      if (selectedFilters[filterSlug] && selectedFilters[filterSlug].length > 0) {
        setShowButton(true)
      }
    })
  }

  useEffect(() => {
    showButtonIfFiltersIsset()
  }, [selectedFilters])

  return (
    <div>
      {showButton && (
        <div
          className={classNames('search-page__sidebar-reset-button', {
            'search-page__sidebar-reset-button--after-search': afterSearch
          })}
          onClick={unselectAllFilters}
        >
          Nulstil filtre
        </div>
      )}
    </div>
  )
}